<rwidget-alert></rwidget-alert>

<div class="show-mobile hide-desktop">
    <div class="mb-4 w-full bg-white py-4 shadow">
        <div class="flex flex-row items-center justify-center">
            <ridango-ui-back-button
                class="absolute left-0 ml-2"
                *ngIf="env.IS_MOBILE_APP"
                (click)="handleBackClicked()"></ridango-ui-back-button>
            <h1
                class="var-app-light-dark:bold text-center text-base font-semibold leading-5"
                [ngClass]="{ 'px-10': env.IS_MOBILE_APP }">
                {{ 'PAYMENT_SETTINGS' | translate }}
            </h1>
        </div>
    </div>

    <!-- Credit Cards Section -->
    <div class="no-border-radius mb-4 box-border w-full bg-white p-4 shadow">
        <h2
            class="var-app-light-dark:semibold mb-2 text-xs font-semibold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow">
            {{ 'YOUR_CREDIT_CARDS' | translate }}
        </h2>
        <mat-divider></mat-divider>
        <ng-container *ngFor="let card of creditCards">
            <div class="flex-align-center flex justify-between py-4">
                <div
                    class="flex items-center"
                    [attr.aria-label]="
                        (card.type === 'mastercard' ? 'Mastercard' : 'Visa') +
                        ('CARD_ENDING_IN' | translate) +
                        card.lastFourDigits +
                        ('EXPIRES_ON' | translate) +
                        card.expiryDate
                    "
                    tabindex="0">
                    <div aria-hidden="true">
                        <div class="flex items-center">
                            <div class="mr-4">
                                <img class="h-5 w-8 dark:filter-yellow" [src]="card.logoPath" alt="" />
                            </div>
                            <div>
                                <p class="align-middle text-base font-bold leading-5 tracking-normal">
                                    {{ card.type === 'mastercard' ? 'Mastercard' : 'Visa' }}
                                </p>
                                <p
                                    class="text-base font-light leading-5 tracking-wide text-[#414141] dark:text-contrast-yellow">
                                    ••••• {{ card.lastFourDigits }} | {{ card.expiryDate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <button
                    class="text-primary-danger flex h-8 w-8 items-center justify-center rounded-full transition-opacity hover:bg-gray-100 hover:opacity-80"
                    [attr.aria-label]="
                        ('DELETE_CARD' | translate) +
                        ' for ' +
                        (card.type === 'mastercard' ? 'Mastercard' : 'Visa') +
                        ('CARD_ENDING_IN' | translate) +
                        card.lastFourDigits
                    "
                    (click)="handleDeleteCreditCard(card.id)">
                    <mat-icon class="!h-8 !w-8" svgIcon="trash-bin" aria-hidden="true"></mat-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
        </ng-container>

        <ion-button
            class="m-0 mt-4 w-full"
            [attr.aria-label]="'ADD_NEW_CREDIT_CARD' | translate"
            (click)="handleAddNewCreditCard()"
            size="large"
            fill="clear">
            <ion-label class="var-app-light:text-primary text-base font-bold normal-case">
                <span class="icon icon-plus"></span> {{ 'ADD_NEW_CREDIT_CARD' | translate }}
            </ion-label>
        </ion-button>
    </div>

    <!-- Company Invoice Section -->
    <div class="no-border-radius box-border w-full bg-white p-4 shadow" *ngIf="env.COMPANY_INVOICE_PAYMENT !== false">
        <h2
            class="mb-2 text-xs font-semibold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow">
            {{ 'COMPANY_INVOICE_PAYMENT_LABEL' | translate }}
        </h2>
        <mat-divider></mat-divider>
        <ng-container *ngFor="let organization of organizations">
            <div class="flex-align-center flex justify-between py-4">
                <p>{{ organization.company_name }}</p>
                <mat-icon class="text-primary">close</mat-icon>
            </div>
            <mat-divider></mat-divider>
        </ng-container>

        <ion-button
            class="m-0 mt-4 w-full"
            [attr.aria-label]="'ADD_COMPANY' | translate"
            (click)="handleAddCompanyClicked()"
            size="large"
            fill="clear">
            <ion-label class="text-base font-bold normal-case">
                <span class="icon icon-plus"></span> {{ 'ADD_COMPANY' | translate }}
            </ion-label>
        </ion-button>
    </div>
</div>
